export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_23.60049dcd.jpg";